export function canTakeOverConversation(conversation, isAssignedToMe) {
    return (!isAssignedToMe && !conversation.is_closed && !!conversation.assignment);
}
